enum FolderConstantPath {
  MEDICAL = 'medicalcertificate',
  DOCUMENT = 'document',
  OVERSEASMISSION = 'overseasmission',
  MATERIAL_DOCUMENT = 'materialdocument',
  TENDER_PRICING = 'tenderpricing',
}

export default FolderConstantPath;
